export const Environment = {
  get apiUrl() {
    if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL
    }

    throw new Error('There is not API URL configured')
  },


  get apiSdkUrl() {
    if (process.env.REACT_APP_API_SDK_URL) {
      return process.env.REACT_APP_API_SDK_URL
    }

    throw new Error('There is not API SDK URL configured')
  }
}
